import axios from "axios";

export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "http://localhost:8001").replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("adopt_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  if (cfg.method && !["get", "head", "options"].includes(cfg.method)) {
    cfg.headers["X-CSRF-Token"] = "1";
    cfg.headers["X-Requested-With"] = "XMLHttpRequest";
  }
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      clearAuth();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    const detail = err.response?.data?.detail;
    if (Array.isArray(detail)) {
      err.response.data.detail = detail.map(d => d.msg).join("; ");
    }
    return Promise.reject(err);
  }
);

export const saveAuth = (token, user) => {
  localStorage.setItem("adopt_token", token);
  localStorage.setItem("adopt_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("adopt_token");
  localStorage.removeItem("adopt_user");
};
export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("adopt_user")); } catch { return null; }
};
export const getToken = () => localStorage.getItem("adopt_token");

export const rarityClass = (r) => {
  if (!r) return "rarity-common";
  if (r.includes("legendary")) return "rarity-legendary";
  if (r.includes("ultra")) return "rarity-ultra";
  if (r.includes("rare")) return "rarity-rare";
  if (r.includes("uncommon")) return "rarity-uncommon";
  return "rarity-common";
};

export const exactValue = (item, variant = "normal", potion = "flyride") => {
  if (!item) return 0;
  if (item.type !== "pets") return item.value || 0;
  const prefix = variant === "neon" ? "value_neon" : variant === "mega" ? "value_mega" : "value";
  let key;
  if (potion === "none") key = `${prefix}_no_potion`;
  else if (potion === "fly") key = `${prefix}_fly`;
  else if (potion === "ride") key = `${prefix}_ride`;
  else key = prefix;
  return item[key] || item[prefix] || item.value || 0;
};

const _audioCtx = () => {
  const c = new (window.AudioContext || window.webkitAudioContext)();
  if (c.state === "suspended") c.resume();
  return c;
};
const _note = (ctx, freq, start, dur, gain = 0.12, type = "sine") => {
  const o = ctx.createOscillator(); const g = ctx.createGain();
  o.type = type; o.frequency.value = freq; g.gain.setValueAtTime(gain, start);
  g.gain.exponentialRampToValueAtTime(0.001, start + dur);
  o.connect(g); g.connect(ctx.destination); o.start(start); o.stop(start + dur);
};
export const playSound = (type = "pop") => {
  try {
    const ctx = _audioCtx(); const t = ctx.currentTime;
    if (type === "pop") {
      _note(ctx, 880, t, 0.08, 0.1, "sine");
      _note(ctx, 1100, t + 0.04, 0.1, 0.08, "sine");
    } else if (type === "click") {
      _note(ctx, 660, t, 0.04, 0.06, "square");
    } else if (type === "ding") {
      _note(ctx, 1320, t, 0.3, 0.12, "sine");
      _note(ctx, 1760, t + 0.06, 0.25, 0.06, "sine");
    } else if (type === "success") {
      _note(ctx, 523, t, 0.12, 0.1, "sine");
      _note(ctx, 659, t + 0.1, 0.12, 0.1, "sine");
      _note(ctx, 784, t + 0.2, 0.12, 0.1, "sine");
      _note(ctx, 1047, t + 0.3, 0.3, 0.12, "sine");
    } else if (type === "error") {
      _note(ctx, 400, t, 0.15, 0.1, "sawtooth");
      _note(ctx, 300, t + 0.15, 0.15, 0.1, "sawtooth");
      _note(ctx, 220, t + 0.3, 0.25, 0.08, "sawtooth");
    } else if (type === "notification") {
      _note(ctx, 880, t, 0.08, 0.08, "triangle");
      _note(ctx, 660, t + 0.08, 0.08, 0.08, "triangle");
      _note(ctx, 880, t + 0.16, 0.12, 0.1, "triangle");
    } else if (type === "whoosh") {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "sawtooth"; o.frequency.setValueAtTime(300, t);
      o.frequency.exponentialRampToValueAtTime(1200, t + 0.2); g.gain.setValueAtTime(0.06, t);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.25); o.connect(g); g.connect(ctx.destination);
      o.start(t); o.stop(t + 0.25);
    } else if (type === "coin") {
      _note(ctx, 1319, t, 0.06, 0.1, "square");
      _note(ctx, 1760, t + 0.06, 0.15, 0.08, "square");
    } else if (type === "ban") {
      _note(ctx, 440, t, 0.18, 0.28, "square");
      _note(ctx, 349, t + 0.2, 0.18, 0.28, "square");
      _note(ctx, 262, t + 0.4, 0.18, 0.28, "square");
      _note(ctx, 175, t + 0.6, 0.7, 0.25, "sawtooth");
      _note(ctx, 87, t + 0.9, 0.9, 0.22, "sawtooth");
      const o2 = ctx.createOscillator(); const g2 = ctx.createGain();
      o2.type = "sine"; o2.frequency.value = 55;
      g2.gain.setValueAtTime(0.15, t + 0.6); g2.gain.exponentialRampToValueAtTime(0.001, t + 2.2);
      o2.connect(g2); g2.connect(ctx.destination); o2.start(t + 0.6); o2.stop(t + 2.2);
    } else {
      _note(ctx, 600, t, 0.12, 0.1, "triangle");
    }
  } catch {}
};
